<template>
  <div class="container">
    <div class="top">
      <svg-icon icon-class="success"></svg-icon>
      <div class="label">预约成功</div>
      <div class="sub-label">请携带预约时使用身份证件检票入馆</div>
    </div>
    <div class="info-item">参观日期：{{ detail.dates }}</div>
    <div class="info-item">参观人数：{{ detail.list.length }}人</div>
    <div class="user-list">
      <div class="user-item" v-for="(item, index) in detail.list" :key="index">
        <div class="number">{{ index + 1 }}</div>
        <div class="label">身份证</div>
        <div class="value">{{ item }}</div>
      </div>
    </div>
    <div class="btn-cancel" @click="cancel">取消预约</div>
  </div>
</template>
<script>
import {bookCancel, bookDetail} from '@/api/home'

export default {
  components: {},
  data() {
    return {
      token: '',
      detail: {
        dates: '',
        list: []
      },
    }
  },
  watch: {
    $route: {
      handler(nv, ov) {
      },
      deep: true,
      immediate: true,
    },
  },
  beforeCreate() {
  },
  created() {
    document.title = "我的预约"
    let token = this.$route.query.token
    if (token) {
      this.token = token
      this.getDetail()
    } else {
      window.location.href = process.env.VUE_APP_API_URL + '/sjd/auth'
    }
  },
  beforeDestroy() {

  },
  beforeMount() {
  },
  destroyed() {

  },
  mounted() {

  },
  methods: {
    getDetail() {
      bookDetail({token: this.token}).then(res => {
        console.log(res)
        this.detail = res.data
      }).catch(error => {
        console.log(error)
      })
    },
    cancel() {
      bookCancel({token: this.token}).then(res => {
        this.$router.push({path: '/', query: {token: this.token}})
      }).catch(error => {
        console.log(error)
      })
    }
  },
}
</script>

<style lang="less" scoped>
.container {
  max-width: 750px;
  margin: 0 auto;
  padding: 0 18px 80px 18px;
  position: relative;
  min-height: 100vh;
  overflow-y: auto;

  .top {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    svg {
      width: 100px;
      height: 100px;
      margin: 44px 0 17px 0;
    }

    .label {
      color: #000;
      font-size: 16px;
      line-height: 22px;
      font-weight: 600;
    }

    .sub-label {
      font-size: 12px;
      line-height: 17px;
      color: #787D86;
      margin: 4px 0 42px 0;
    }
  }

  .info-item {
    width: 100%;
    height: 40px;
    line-height: 40px;
    border-top: 1px solid #E2E4E9;
    color: #10141B;
    font-weight: 600;
  }

  .user-list {
    border-top: 1px solid #E2E4E9;

    .user-item {
      height: 40px;
      display: flex;
      align-items: center;
      color: var(---, #3E4551);

      .number {
        width: 30px;
      }

      .label {
        width: 70px;
        margin: 0 10px 0 0;
      }

      .value {
        flex: 1;
      }

    }

  }

  .btn-cancel {
    width: 80px;
    height: 30px;
    border-radius: 10px;
    border: 1px solid var(---, #D0D1D6);
    margin: 0 auto;
    text-align: center;
    line-height: 30px;
    color: var(---, #787D86);
    margin-top: 46px;
  }
}
</style>
